import React, { useMemo, useState } from 'react';
import { CTitle } from '../../components/Widget';
import { useParams } from 'react-router-dom';
import { useUpdateComponentState } from '../../../hooks';
import PracticeLeftBg from './../../../../../../assets/education/ptm/practice_left_bg.png';
import PracticeRightBg from './../../../../../../assets/education/ptm/practice_right_bg.png';
import PracticeTopBg from './../../../../../../assets/education/ptm/practice_top_bg.png';
import Quiz from '../../components/Quiz';
interface ISection2Props {
  settings: any;
}

const Section2: React.FunctionComponent<ISection2Props> = ({ settings }) => {
  const ID = '3';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  // const { updateParagraphState } = useStore();
  const paragraphsSettings = useMemo(
    () => settings?.paragraphs[2],
    [settings?.paragraphs]
  );
  const { quiz } = paragraphsSettings;
  const updateComponentState = useUpdateComponentState();
  const [state, setState] = useState({
    quiz: false,
  });
  return (
    <div className="topic-section-3">
      <img className="section-top-bg" src={PracticeTopBg} alt="" />
      <CTitle title={paragraphsSettings?.title} />
      <div className="practice">
        <div className="practice-item practice-left">
          <img src={PracticeLeftBg} alt="" />
          <div className="practice-item-title">
            {paragraphsSettings?.l1Title}
          </div>
          {paragraphsSettings?.l1?.map((item: any, index: number) => (
            <div className="practice-item-item" key={index}>
              <div className="item-num">{index + 1}</div>
              {item}
            </div>
          ))}
        </div>
        <div className="practice-item practice-right">
          <img src={PracticeRightBg} alt="" />
          <div
            className="practice-item-title"
            dangerouslySetInnerHTML={{ __html: paragraphsSettings?.l2Title }}
          />
          {paragraphsSettings?.l2?.map((item: any, index: number) => (
            <div className="practice-item-item" key={index}>
              <div className="item-num">{index + 1}</div>
              {item}
            </div>
          ))}
        </div>
      </div>
      <div id="education-ptm-section2-question" className="topic-quiz">
        <Quiz
          title={paragraphsSettings?.questionTitle}
          description={quiz?.description}
          question={quiz?.question}
          options={quiz?.options}
          onCompleted={() => {
            setState({ ...state, quiz: true });
            updateComponentState(
              p_course,
              p_topic,
              ID,
              'education-ptm-section2-question'
            );
          }}
        />
      </div>
    </div>
  );
};

export default Section2;
